import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { ICON_SIZE } from '../../design-system';
import './MobileAskPill.css';

/**
 * Ask — the one filled control on any phone screen that has an AI surface.
 *
 * It is the same object everywhere: in the reader it sits in the dock beside
 * Back; on a list or a deck it floats above whatever the screen's own bottom
 * chrome is. One shape, one entry rule, so "ask about this" never has to be
 * relearned per screen. Collapsed it drops the label and becomes a disc in the
 * same position, because the collapse removes chrome, never an exit.
 */
const MobileAskPill = ({
  onClick,
  expanded,
  collapsed = false,
  floating = false,
  label,
  className = '',
  ...rest
}) => {
  const { t } = useTranslation('reader');

  return (
    <button
      type="button"
      className={[
        'mobile-ask-pill',
        collapsed ? 'mobile-ask-pill--collapsed' : '',
        floating ? 'mobile-ask-pill--floating' : '',
        className,
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      aria-expanded={expanded}
      aria-label={label || t('aiChat.openAIChat')}
      {...rest}
    >
      <Sparkles size={ICON_SIZE.md} aria-hidden="true" />
      <span className="mobile-ask-pill__label">{t('mobile.ask')}</span>
    </button>
  );
};

export default MobileAskPill;
